import React, { useEffect, useRef, useState } from 'react';
import Title from '../../components/Title/Title';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link, useLocation } from 'react-router-dom';



function useIsLaptop() {
  const [isLaptop, setIsLaptop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsLaptop(window.innerWidth >= 1024); // لو الشاشة من 1024px أو أكبر اعتبرها لاب
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isLaptop;
}

export default function PlogsSection() {

  const Api_Url = process.env.REACT_APP_API_BASE_URL;

  const [plog, setPlog] = useState([]);


  const swiperRef = useRef(null);
  const isLaptop = useIsLaptop();

  const location = useLocation();



  const handleMouseEnter = () => {
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.start();
    }
  };



  useEffect(() => {
    fetch(`${Api_Url}/plog/show/all`)
      .then((res) => res.json())
      .then((data) => {
        setPlog(data);
      });
  }, []);


  console.log(plog);

  return (
    <section className="relative w-[80%] mx-auto mt-5 h-full">
      {location.pathname != '/blog' ? (
        <div className="text-center mb-5">
          <Title text="المدونه" center />
        </div>
      )
        :
        (<></>)
      }


      {
        location.pathname === '/blog' && isLaptop ?
          (
            <div className='w-full grid xl:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-4 gap-6'>
              {plog?.map((item) => (
                <div
                  className="relative w-full h-[470px] bg-[#F79421] rounded-[25px] overflow-hidden mb-9 content-visibility-auto"
                  key={item.id}
                >
                  <Link to={`/blog/${item.id}/${item.title}`} >
                    <div className="w-full h-[250px]">
                      <img src={item.img} alt={item.AltImg} className="w-full h-full" loading="lazy" />
                    </div>

                    <div className="absolute left-1/2 top-1/1 -translate-x-1/2  w-full text-center px-2">
                      <h1 className="text-white text-xl font-bold">{item.title}</h1>
                      <p className="w-[95%] mx-auto text-[#ffffffc2] pt-1">{item.description}</p>
                    </div>

                    <div className="absolute bottom-2 left-1/2 -translate-x-1/2">

                      <button className="border border-[#880807] w-[150px] lg:w-[190px] h-[50px] rounded-tr-[40px] rounded-bl-[40px] text-white font-semibold hover:bg-[#880807] duration-500">
                        شاهد المزيد
                      </button>
                    </div>
                  </Link>
                </div>
              ))}

            </div>

          )
          :
          (


            <div
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onTouchStart={handleMouseEnter}
              onTouchEnd={handleMouseLeave}
            >
              <Swiper
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                }}
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 10 },
                  768: { slidesPerView: 2, spaceBetween: 20 },
                  1024: { slidesPerView: 3, spaceBetween: 30 },
                  1800: { slidesPerView: 4, spaceBetween: 30 },
                }}
                modules={[Autoplay, Pagination]}
              >
                {plog?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <Link to={`/blog/${item.id}/${item.title}`}>
                      <div className="relative w-full h-[470px] bg-[#F79421] rounded-[25px] overflow-hidden mb-9 content-visibility-auto">
                        <div className="w-full h-[240px]">
                          <img src={item.img} alt={item.AltImg} className="w-full h-full" loading="lazy" />
                        </div>
                        <div className="mt-16 w-full text-center absolute left-1/2 top-1/1 -translate-x-1/2  -translate-y-1/2">
                          <h1 className="text-white text-lg w-[95%] mx-auto  font-bold">{item.title}</h1>
                          <p className="w-[95%] text-xs mx-auto text-[#ffffffc2] pt-1">{item.description}</p>
                        </div>
                        <div className="absolute bottom-2 left-1/2 -translate-x-1/2">

                          <button className="border border-[#880807] w-[150px] lg:w-[190px] h-[50px] rounded-tr-[40px] rounded-bl-[40px] text-white font-semibold hover:bg-[#880807] duration-500">
                            شاهد المزيد
                          </button>

                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )



      }

    </section >
  );
}
